/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], function(){
	return {
		layout: {
			type: 'genericPage',
			layoutPositioning: 'relative',
			pageSize: {
				width: 1280,
				height: 720
			},
			showGrid: true,
			snapGrid: true,
			snapObjects: true
		}
	};
});
